module.exports = __webpack_public_path__ + "img/f6-3.254454d7.png";